/**
 * Delete analytics identifier storage on this origin (BR-8): GA `_ga*` and PostHog `ph_*` cookies
 * (host-only, for this hostname, and for each parent domain such as `.resida.me`) and PostHog
 * `ph_*` localStorage / sessionStorage keys. PostHog's opt-out marker (`__ph_opt_in_out_*`) does not
 * match either prefix and is kept on purpose: it records the opt-out and identifies no one (BR-7).
 */
const COOKIE_PREFIXES = ['_ga', 'ph_'];
const STORAGE_PREFIX = 'ph_';
function cookieDomains(hostname) {
    const parts = hostname.split('.');
    const domains = [hostname];
    // Every parent domain with at least two labels (resida.me, not me).
    for (let i = 1; i < parts.length - 1; i++)
        domains.push(`.${parts.slice(i).join('.')}`);
    return domains;
}
function purgeStorage(storage) {
    const keys = [];
    for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key?.startsWith(STORAGE_PREFIX))
            keys.push(key);
    }
    for (const key of keys)
        storage.removeItem(key);
}
export function purgeAnalyticsStorage() {
    if (typeof document === 'undefined')
        return;
    try {
        const names = document.cookie
            .split(';')
            .map((part) => part.trim().split('=')[0])
            .filter((name) => !!name && COOKIE_PREFIXES.some((p) => name.startsWith(p)));
        const expire = 'Max-Age=0; Path=/';
        for (const name of names) {
            document.cookie = `${name}=; ${expire}`;
            for (const domain of cookieDomains(window.location.hostname)) {
                document.cookie = `${name}=; ${expire}; Domain=${domain}`;
            }
        }
        purgeStorage(window.localStorage);
        purgeStorage(window.sessionStorage);
    }
    catch {
        // Best-effort: storage can be unavailable (privacy mode); consent handling must never break the app (BR-13).
    }
}
//# sourceMappingURL=purge.js.map